import * as React from "react";
import * as PropTypes from "prop-types";
import Headerbar from "./components/Headerbar/Headerbar";
import { logOut } from "../../auth/logout";

import { NavStructurePropTypes, ToolbarItemsPropTypes } from "./vars/vars";

function appendLogoutToNav(navStructure: any) {
  const logoutMenuItem = {
    desktopOnly: true,
    label: "Log out",
    icon: "logout",
    onClick: function() {
      logOut();
    }
  };

  const lasNavMenu = navStructure[navStructure.length - 1];
  return [
    ...navStructure.slice(0, navStructure.length - 1),
    {
      ...lasNavMenu,
      menuItems: [...lasNavMenu.menuItems, logoutMenuItem]
    }
  ];
}

export class MyAccountHeaderBarContainer extends React.Component<any, any> {
  static propTypes = {
    ...NavStructurePropTypes,
    ...ToolbarItemsPropTypes,
    logoutUrl: PropTypes.string,
    sandbox: PropTypes.bool
  };

  render() {
    const { logoutUrl, navStructure, sandbox, toolbarItems } = this.props;

    const navStructureWithLogoutMenuItem = appendLogoutToNav(navStructure);

    return (
      <Headerbar
        navStructure={navStructureWithLogoutMenuItem}
        className="style--rebrand"
        toolbarItems={toolbarItems}
        sandbox={sandbox}
        logoutUrl={logoutUrl}
      />
    );
  }
}
